export const API_URL = "https://ocoruysjl5.execute-api.ap-south-1.amazonaws.com/LiveMode"
// export const API_URL = "http://127.0.0.1:3000"

export const DarkModePrimaryColor = "#F5141F";
// Please turn off for no banner as "false"
export const showBanner = false;

